/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Content_Identity_WarningInputs */

const fr_legal_content_identity_warning = /** @type {(inputs: Legal_Content_Identity_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La copie servile du site ou de son identité visuelle est strictement interdite.`)
};

const en_legal_content_identity_warning = /** @type {(inputs: Legal_Content_Identity_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct copying of the site or its visual identity is strictly prohibited.`)
};

/**
* | output |
* | --- |
* | "Direct copying of the site or its visual identity is strictly prohibited." |
*
* @param {Legal_Content_Identity_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_content_identity_warning = /** @type {((inputs?: Legal_Content_Identity_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Content_Identity_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_content_identity_warning(inputs)
	return en_legal_content_identity_warning(inputs)
});